import { createAction } from '@reduxjs/toolkit';

export const clearPasskeyIds = createAction('NATIVE_CLIENT::CLEAR_PASSKEY_IDS');
